import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import ProductsSection from "../sections/ProductsSection";
import UsesBenefits from "../sections/UsesBenefits";
import HowToUse from "../sections/HowToUse";
import CompareTable from "../sections/CompareTable";
import ContactSection from "../sections/ContactSection";
import RKMainHome from "../components/Dashboard/RKMainHome";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/auth/login" element={<Login />} />
      <Route path="/auth/register" element={<Register />} />
      <Route path="/products" element={<ProductsSection />} />
      <Route path="/benefits" element={<UsesBenefits />} />
      <Route path="/how-to-use" element={<HowToUse />} />
      <Route path="/compare" element={<CompareTable />} />
      <Route path="/contact" element={<ContactSection />} />
      <Route path="/rkhome" element={<RKMainHome />} />
    </Routes>
  );
}
